import cogoToast from 'cogo-toast';
import { takeLatest, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import {
  CREATE_UTILITY_REQUEST,
  CREATE_UTILITY_REQUEST_SUCCESS,
  CREATE_UTILITY_REQUEST_ERROR,
} from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* createUtilityRequest({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/utility-request/create`,
      method: 'POST',
      headers: { ...filteredHeaders, 'Content-Type': 'application/json' },
      data: payload.body,
    });

    if (response.status === 200 || response.status === 201) {
      cogoToast.success(payload.body.is_draft ? 'Saved as draft' : response?.data?.message || 'Request saved');
      yield put({
        type: CREATE_UTILITY_REQUEST_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message || 'Something went wrong');
      yield put({ type: CREATE_UTILITY_REQUEST_ERROR, payload: response?.data?.message });
    }
  } catch (error) {
    cogoToast.error('Something went wrong');
    yield put({ type: CREATE_UTILITY_REQUEST_ERROR, payload: error });
  }
}

export function* watchCreateUtilityRequest() {
  yield takeLatest(CREATE_UTILITY_REQUEST, createUtilityRequest);
}

function* createUtilityRequestSaga() {
  yield all([fork(watchCreateUtilityRequest)]);
}

export default createUtilityRequestSaga;
